import { Route, Routes } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { InventoryPage } from './InventoryPage';
import { ItemDetailPage } from './ItemDetailPage';
import { AdminPage } from './AdminPage';
import { CraftPage } from './CraftPage';

/**
 * Arche wrapper for LitSquad — provides ArcheLayout with sidebar and
 * handles sub-routing. Mirrors DfeArchePage's pattern so the two arches
 * feel consistent.
 */
export function LitSquadArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<InventoryPage />} />
        <Route path="/item/:itemId" element={<ItemDetailPage />} />
        <Route path="/craft" element={<CraftPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </ArcheLayout>
  );
}
